export const not = (value) => !value;
